import { render, staticRenderFns } from "./CollectesView.vue?vue&type=template&id=9ff28288&scoped=true"
import script from "./CollectesView.vue?vue&type=script&lang=js"
export * from "./CollectesView.vue?vue&type=script&lang=js"
import style0 from "./CollectesView.vue?vue&type=style&index=0&id=9ff28288&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ff28288",
  null
  
)

export default component.exports